module.exports = __webpack_public_path__ + "static/locum-staffing-e316eadfa0c40a0923774521736f86f7.jpeg";